import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "../Pages/HomePage";
import NavbarComponent from "./NavbarComponent";
import LoginMessageShowing from "./LoginMessageShowing";

import { connect } from "react-redux";
import { addBus } from "../redux/ActionCreators";
import {
  fetchBookingByRoute,
  addNewBooking,
  addBoardingPoint,
  addDroppingPoint,
  addJourneyDetails,
  addUserDetailsToState,
  clearBookingState, addSeatToArray,
  removeSeats, email, mobile, updateSeatWithPerson, addContactDetails
} from "../redux/ActionCreators";
import FooterComponent from "./FooterComponent";
import Unauthorised from "../Pages/Unauthorised";
import BusSearchPage from "../Pages/BusSearchPage";
import MyBookingsPage from "../Pages/MyBookingsPage";

import AddBus from "../Pages/Operator/AddBus";
import AddOperator from "../Pages/Operator/AddOperator";
import MyBus from "../Pages/Operator/MyBus";
import ProtectedRoute from "./ProtectedRoute";
import PersistLogin from "./PersistLogin";
import TicketComponent from "./TicketComponent";
import OperatorRequestForm from "../Pages/OperatorRequestForm";
import OperatorList from "../Pages/Admin/OperatorList";
import OperatorHome from "../Pages/Operator/OperatorHome.js";
import OperatorBookings from "../Pages/Operator/OperatorBookings";
import OperatorTicketComponent from "../Pages/Operator/OperatorTicketComponent";
import NoBuses from "./NoBuses";
import CheckoutPage from "../Pages/CheckoutPage";

const mapDispatchToProps = (dispatch) => ({
  updateSeatWithPerson: (seats) => dispatch(updateSeatWithPerson(seats)),
  addContactDetails: (email, mobile) => dispatch(addContactDetails(email, mobile)),
  addSeatToArray: (seat) => dispatch(addSeatToArray(seat)),
  removeSeats: (seats) => dispatch(removeSeats(seats)),
  addBus: (busarray) => dispatch(addBus(busarray)),
  fetchBookingByRoute: (bookingarray) =>
    dispatch(fetchBookingByRoute(bookingarray)),
  addNewBooking: (bus_id, routeId, seats) => dispatch(addNewBooking(bus_id, routeId, seats)),
  addBoardingPoint: (boardingPoint) =>
    dispatch(addBoardingPoint(boardingPoint)),
  addDroppingPoint: (droppingPoint) =>
    dispatch(addDroppingPoint(droppingPoint)),
  addJourneyDetails: (originCity, destinationCity, dateofJourney) =>
    dispatch(addJourneyDetails(originCity, destinationCity, dateofJourney)),
  addUserDetailsToState: (userinfo) => dispatch(addUserDetailsToState(userinfo)),
  clearBookingState: () => dispatch(clearBookingState())

});
const mapStateToProps = (state) => {
  return {
    bus: state.busesarray,
    booking: state.booking,
    user: state.user
  };
};

const MainComponent = (props) => {
  return (
    <>
      <NavbarComponent userinfo={props.user.userinfo} addUserDetailsToState={props.addUserDetailsToState} newBooking={props.booking.newBooking}
      />


      <Routes>
        <Route path="/checkout" element={<CheckoutPage userid={props.user.userinfo?.id} journeyDetails={props.booking.journeydetails} email={props.booking.email} mobile={props.booking.mobile} newBooking={props.booking.newBooking} />} ></Route>
        <Route path="/" element={<Navigate replace to="/home" />} />
        <Route
          path="/home"
          element={
            <HomePage
              addBus={props.addBus}
              fetchBookingByRoute={props.fetchBookingByRoute}
              addJourneyDetails={props.addJourneyDetails}
            />
          }
        ></Route>
        <Route path='/mybooking/:ticketId'
          element={<TicketComponent />}>


        </Route>
        <Route
          path="/bussearch"
          element={
            <BusSearchPage
              busesarray={props.bus}
              removeSeats={props.removeSeats}
              addSeatToArray={props.addSeatToArray}
              bookingarray={props.booking}
              addNewBooking={props.addNewBooking}
              newBooking={props.booking.newBooking}
              addBoardingPoint={props.addBoardingPoint}
              addDroppingPoint={props.addDroppingPoint}
              journeyDetails={props.booking.journeydetails}
              userid={props.user.userinfo?.id}
              clearBookingState={props.clearBookingState}
              addContactDetails={props.addContactDetails}
              updateSeatWithPerson={props.updateSeatWithPerson}
            />
          }
        ></Route>
        <Route element={<PersistLogin user={props.user} />}>
          <Route element={<ProtectedRoute user={props.user} allowedRoles={[2001]} />}>
            <Route path="/mybookings" element={<MyBookingsPage userid={props.user.userinfo?.id} />} />
          </Route>
        </Route>
        <Route path="/unauthorised" element={<Unauthorised />} />
        <Route path="/notloggedin" element={<LoginMessageShowing />} />
        <Route path="/nobuses" element={<NoBuses />} />
        <Route element={<ProtectedRoute user={props.user} allowedRoles={[1900]} />}>
          <Route path="operator" element={<OperatorHome />} >
            <Route path="addbus" element={<AddBus userid={props.user.userinfo?.id} />}></Route>
            <Route path="mybookings" element={<OperatorBookings userid={props.user.userinfo?.id} />}></Route>
            <Route path="mybus" element={<MyBus userid={props.user.userinfo?.id} />}></Route>
            <Route path="booking/:ticketId" element={<OperatorTicketComponent />}></Route>

          </Route>



        </Route>
        <Route path="/operator/requestform" element={<OperatorRequestForm userid={props.user.userinfo?.id} />}></Route>
        <Route element={<ProtectedRoute user={props.user} allowedRoles={[5150]} />}>
          <Route path="/admin/operators" element={<OperatorList userid={props.user.userinfo?.id} />}></Route>
        </Route>

      </Routes >
      <FooterComponent />
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(MainComponent);
